
import { css } from 'lit';
export default css`
pc-menu-dropdown:not([has-ancillary-slot])
  [slot='primary']
  pc-menu-link:last-child
  a{
  border-radius:0 0 var(--spacing-4) var(--spacing-4);
  border-bottom:none;
}

@media (min-width: 768px){
  pc-menu-dropdown:not([has-ancillary-slot])
    [slot='primary']
    pc-menu-link:last-child
    a{
    border-radius:0 0 0 var(--spacing-4);
  }
}

@media (min-width: 992px){
  pc-menu-dropdown:not([has-ancillary-slot])
    [slot='primary']
    pc-menu-link:last-child
    a{
    border-radius:0;
  }
}

pc-menu-dropdown pc-detail{
  margin-bottom:var(--spacing-6);
  display:block;
  color:var(--purple-indigo);
}

pc-menu-dropdown [slot='ancillary'] .ancillary-menu > li{
  margin-bottom:var(--spacing-6);
}

pc-menu-dropdown [slot='ancillary'] .ancillary-menu > li:last-child{
  border-bottom:none;
  margin-bottom:0;
  padding-bottom:0;
}

@media (min-width: 992px){
  pc-menu-dropdown [slot='ancillary'] .ancillary-menu > li{
    border-bottom:2px solid var(--purple-medium-neutral);
    margin-bottom:var(--spacing-4);
    padding-bottom:var(--spacing-4);
  }
}
`;